import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiGet } from '../../../lib/api';
import { Plane } from 'lucide-react';
import { formatINR } from '../../../lib/format';

const STATUS_COLORS = {
  draft: 'bg-slate-100 text-slate-600', pending_approval: 'bg-amber-100 text-amber-700',
  approved: 'bg-emerald-100 text-emerald-700', rejected: 'bg-red-100 text-red-600',
  completed: 'bg-blue-100 text-blue-700', cancelled: 'bg-slate-100 text-slate-400',
};

export default function MyTravel() {
  const [data, setData] = useState(null);
  const nav = useNavigate();
  useEffect(() => { apiGet('/hr/me/travel').then(setData).catch(() => setData({ linked: false, requests: [] })); }, []);
  if (!data) return <div className="p-8 text-slate-500">Loading…</div>;

  return (
    <div className="space-y-5 p-6 md:p-8 max-w-3xl" data-testid="my-travel-page">
      <div className="flex items-center justify-between">
        <div>
          <div className="text-[10px] font-display font-bold uppercase tracking-[0.2em] text-[#3b4872] mb-2">My Workspace</div>
          <h1 className="font-display text-3xl font-extrabold tracking-tight">My Travel</h1>
          <p className="text-sm text-slate-600 mt-1">Your travel requests and expense claims.</p>
        </div>
        <button onClick={() => nav('/app/hr/travel/requests')} data-testid="raise-travel-btn" className="px-4 py-2 bg-[#3b4872] text-white rounded-sm text-xs font-display font-bold uppercase tracking-wider hover:bg-[#2e3a5c] flex items-center gap-2"><Plane size={14} /> Raise Request</button>
      </div>

      {data.linked === false && <div className="bg-amber-50 border border-amber-200 rounded-sm p-4 text-sm text-amber-800" data-testid="no-emp">No employee record linked to your login yet.</div>}

      {(data.requests || []).length === 0 ? (
        <div className="text-center py-16 text-slate-400"><Plane size={40} className="mx-auto mb-3 opacity-40" /><p className="text-sm">No travel requests yet.</p></div>
      ) : (
        <div className="bg-white border border-slate-200 rounded-sm divide-y divide-slate-100">
          {data.requests.map((r) => (
            <button key={r.id} onClick={() => nav(`/app/hr/travel/requests/${r.id}`)} data-testid={`my-travel-${r.id}`} className="w-full text-left p-4 hover:bg-slate-50 flex items-center justify-between">
              <div>
                <div className="font-display font-bold text-sm">{r.from_location || '?'} → {r.to_location || '?'}</div>
                <div className="text-[11px] text-slate-500">{r.departure_date || 'TBD'} · {r.mode}{r.estimated_cost ? ` · ${formatINR(r.estimated_cost)}` : ''}</div>
              </div>
              <span className={`text-[9px] font-bold uppercase px-2 py-0.5 rounded-sm ${STATUS_COLORS[r.status]}`}>{r.status.replace('_', ' ')}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
